<mat-table
  [dataSource]="dataSource"
  class="mat-elevation-z2 patientsTable"
  matSort
>
  <ng-container matColumnDef="firstname">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      Prénom
    </mat-header-cell>
    <mat-cell *matCellDef="let patient"> {{ patient.firstname }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="birthname">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      Nom de naissance
    </mat-header-cell>
    <mat-cell *matCellDef="let patient"> {{ patient.birthname }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="lastname">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Nom </mat-header-cell>
    <mat-cell *matCellDef="let patient"> {{ patient.lastname }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="birthdate">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      Date de naissance
    </mat-header-cell>
    <mat-cell *matCellDef="let patient">
      {{ patient.birthdate | amDateFormat: "DD/MM/YYYY" }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="ipp">
    <mat-header-cell *matHeaderCellDef mat-sort-header
      >IPP/SERVICE/UF</mat-header-cell
    >
    <mat-cell *matCellDef="let patient"> {{ patient.ipp }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="productType">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      Type de produit
    </mat-header-cell>
    <mat-cell *matCellDef="let patient">
      {{ "labileBlood." + patient.productType | translate }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="quantity">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      Quantité
    </mat-header-cell>
    <mat-cell *matCellDef="let patient"> {{ patient.quantity }} </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>
<mat-paginator
  #TablePatientsPaginator
  *ngIf="patients.length > 0"
  [pageSize]="4"
  [length]="patients.length"
  showFirstLastButtons
></mat-paginator>

